// Minimal local shape of the user's service-level status. We only need to know
// whether a subscription payload is present. See `@forest/paywall-core`
// ServiceLevelStatus for the full discriminated union (intentionally not
// depended on here to keep focus-challenge lean).
export type ServiceLevelStatus = {
  service_level: string
  subscription?: unknown
}

// "In subscription" ≡ the user currently has an active Forest Plus subscription.
export function isInSubscription(status: ServiceLevelStatus): boolean {
  return !!status.subscription
}
